export const css = {
	root: '_1AVwai6e',
	' _key': 'lcc-rcs/resource-center'
};

export default css;
